var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tariff-contract" }, [
    _vm.hasContract
      ? _c(
          "div",
          {
            staticClass:
              "tariff-contract__column tariff-contract__column--num--1",
          },
          [
            _c(
              "div",
              { staticClass: "tariff-contract__general-info contract-info" },
              [
                _c("div", { staticClass: "contract-info__props" }, [
                  _c(
                    "div",
                    { staticClass: "contract-info__prop contract-prop" },
                    [
                      _c("div", { staticClass: "contract-prop__key" }, [
                        _vm._v("Статус договора"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: `contract-prop__val contract-prop__val--status--${_vm.contractStatus}`,
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.statusName) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "contract-info__prop contract-prop" },
                    [
                      _c("div", { staticClass: "contract-prop__key" }, [
                        _vm._v("Дата заключения"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "contract-prop__val" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("localDate")(_vm.contractStartDate)) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "contract-info__prop contract-prop" },
                    [
                      _c("div", { staticClass: "contract-prop__key" }, [
                        _vm._v("Тариф"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "contract-prop__val" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.contractTariffName) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "contract-info__image",
                  attrs: {
                    src: require("../../assets/images/contract-cat.svg"),
                    alt: "",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _vm.contractStatus === "concluding"
              ? _c("MarginConfirmationBlock", {
                  staticClass: "tariff-contract__confirmation",
                })
              : _vm._e(),
            _vm._v(" "),
            _c("Documents", { staticClass: "tariff-contract__documents-list" }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasContract
      ? _c(
          "div",
          {
            staticClass:
              "tariff-contract__column tariff-contract__column--num--2",
          },
          [
            _c("ContractHistory", {
              staticClass: "tariff-contract__history",
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "contract-history__title" }, [
                          _vm._v("История действий"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3288381744
              ),
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.hasContract
      ? _c("div", { staticClass: "tariff-contract-none" }, [
          _c(
            "div",
            { staticClass: "tariff-contract-none__icon-wr" },
            [
              _c("AppIcon", {
                staticClass: "tariff-contract-none__icon",
                attrs: { name: "file-clock" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tariff-contract-none__title" }, [
            _vm._v("Договор не заключен"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tariff-contract-none__description" }, [
            _vm._v(
              "\n      Для заключения договора обратитесь к аутсорсеру\n    "
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }